import React, { Fragment, cloneElement } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";

import { StickySidebar } from "../sidebar/StickySidebar";
import { Desktop, TabletMobile } from "../../hocs/Responsive";
import { ProfilePicker } from "../profilePicker/ProfilePicker";
import { useIntlTranslate } from "../../hooks";
import { useSelectedProfileId } from "../../pages/settings/useSelectedProfileId";

import "./SettingsSidebarNavigation.scss";

export const SettingsSidebarNavigation = ({
  className,
  menuClassName,
  sidebarMenuHeader,
  tabs,
  activeTabClass,
  ...rest
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const profileId = useSelectedProfileId();

  const onTabClick = (profileId) =>
    navigate(`/settings/${pathname.split("/")[2]}/${profileId}`);

  const currentTab = tabs.find(({ id }) => profileId === id);

  return (
    <Fragment>
      <TabletMobile>
        <ProfilePicker
          {...rest}
          activeTab={profileId}
          activeTabClass={activeTabClass}
          tabs={tabs}
          onTabClick={onTabClick}
        />
      </TabletMobile>
      <Desktop>
        <SettingsLayout
          profileId={profileId}
          sidebar={
            <SettingsSidebar
              menuClassName={menuClassName}
              sidebarMenuHeader={sidebarMenuHeader}
              tabs={tabs}
              activeTab={profileId}
              activeTabClass={activeTabClass}
            />
          }
        >
          {currentTab.content}
        </SettingsLayout>
      </Desktop>
    </Fragment>
  );
};

const SettingsLayout = ({ children, profileId, sidebar }) => (
  <div className="row settings__row">
    {sidebar}
    <div key={profileId} id={profileId} data-id={profileId} className="col-9">
      {children}
    </div>
  </div>
);

const SettingsSidebar = ({ sidebarMenuHeader, tabs, activeTab }) => {
  const translate = useIntlTranslate();

  return (
    <StickySidebar
      sidebarMenuHeader={sidebarMenuHeader}
      activeTab={activeTab}
      tabs={tabs}
    >
      <nav
        className="settings-sidebar__menu"
        aria-label={translate("aria_sidebar_navigation")}
      >
        <ul>
          {_.map(tabs, ({ id, header }) => (
            <li key={id} data-id={id} className="settings-sidebar__item">
              {cloneElement(header, { isActive: activeTab === id })}
            </li>
          ))}
        </ul>
      </nav>
    </StickySidebar>
  );
};
